(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stork-waitlist"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.querySelector('.sw-form-el');
  if (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
    });
  }

  var cells = Array.from(document.querySelectorAll('.sw-grid .sw-grid__cell'));
  if (!cells.length) return;

  var COLORS = [
    { bg: '#0A0A0A', bd: '#0A0A0A' },
    { bg: '#E30613', bd: '#E30613' },
    { bg: 'transparent', bd: 'rgba(10,10,10,0.1)' },
    { bg: 'transparent', bd: 'rgba(10,10,10,0.1)' },
    { bg: 'transparent', bd: 'rgba(10,10,10,0.1)' }
  ];

  function rand(n) { return Math.floor(Math.random() * n); }

  var lit = [];

  function clearLit() {
    lit.forEach(function(c) {
      c.style.background = 'transparent';
      c.style.borderColor = 'rgba(10,10,10,0.1)';
    });
    lit = [];
  }

  function lightRandom() {
    var count = rand(2) + 3;
    for (var i = 0; i < count; i++) {
      var c = cells[rand(cells.length)];
      var col = COLORS[rand(2)];
      c.style.background = col.bg;
      c.style.borderColor = col.bd;
      lit.push(c);
    }
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    lightRandom();
    return;
  }

  function tick() {
    clearLit();
    lightRandom();
    setTimeout(tick, rand(300) + 200);
  }

  tick();
}());

  } catch(e) { console.error(e); }
})();
})();
